import { Component } from "react";
import { HOST } from "../../../../api/config/Constants";

type Props = {
  catalogItem: any
};

export default class extends Component<Props> {

  constructor(props: Props) {
    super(props)
  }

  render() {
    return (
      <img
        src={`${HOST}/${this.props.catalogItem.mediaURL}`}
        loading="lazy"
        alt={this.props.catalogItem.mediaURL}
        style={{
          display: 'block',
          height: '180px',
          objectFit: 'cover',
          width: '100%',
          borderTopLeftRadius: 22.1239,
          borderTopRightRadius: 22.1239
        }}
      />
    );
  }
}
